import React from 'react';
import styles from './index.module.scss';

const HeaderBanner = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>CBNDataBox</h1>
        <h1 className={styles.subTitle}>消费魔盒</h1>
        <p className={styles.description}>
          专业Martech企服工具箱。CBNData围绕策略制定、渠道拓展、用户转化等应用场景，聚合专业的企服工具，提升企业营销增长决策效率，助力企业实现数智化转型。
        </p>
        <a className={styles.organizationNavigator} href="/cbndatabox-new/institutionsettled">
          机构入驻
        </a>
      </div>
    </header>
  );
};
export default HeaderBanner;
